export enum OpenAuthenticationProviders {
  AUTH_ZERO = 'auth0',
}
